import { createRoutesMap } from 'rt-route-map';

export const routesMap = createRoutesMap({
  auth: {
    login: {},
    logout: {},
    registration: {
      ':token': {}
    },
    'reset-password': {
      ':token': {}
    }
  },
  dashboard: {
    'code-status': {},
    profile: {
      edit: {},
      changePassword: {}
    },
    'finance-register': {},
    'completed-work': {
      ':userId': {}
    },
    'debt-list': {
      'debt/:docId': {}
    },
    'order-list': {
      'order/:docId': {}
    },
    'stand-list': {
      'stand/:docId': {},
      'stand-templates': {
        ':templateId': {}
      }
    },
    'traffic-list': {
      'traffic/:docId': {},
      'traffic-templates': {
        ':templateId': {}
      }
    },
    'invoice-list': {
      'invoice/:docId': {
        'general': {},
        'waybill': {},
        'acceptance-certificate': {},
        'service-agreement': {},
        'purchase-agreement': {},
      },
      'invoice-templates': {
        ':templateId': {
          ':typeOfInvoice': {}
        }
      }
    },
    'contract-list': {
      'contract/:docId': {},
      'contract-templates': {
        ':templateId': {}
      }
    },
    storage: {},
    'storage/:folderId': {},
    'talon-list': {
      'talon/:docId': {},
      'talon-templates': {
        ':templateId': {
        }
      }
    },
    'template-editor': {},
    'client-list': {
      'client/:id': {}
    },
    instructions: {},
    'asterisk-settings': {},
    statistics: {},
    'user-management': {}
  }
});
